module.exports = __webpack_public_path__ + "static/laurent-44m-8a291ade666fe854b0c1484b53557e68.jpg";